import { useMemo } from "react";
import { Dispatch, AnyAction } from "redux";
import { useDispatch, useSelector } from "react-redux";

import { ApplicationState } from "../../store/RootReducers";
import {
  eligibilityActions,
  SaveEligibilityRequest,
  GetEligibilityDetails
} from "../../store/eligibility/actions";
import { EligibilityState } from "../../store/eligibility/state";
import {
  LoanCalculationType,
  EligibilityDetails,
  GetStartedLoanCalculation
} from "../../services/eligibilityService/EligibilityService.type";
import { formatEligibilityDetails } from "../../store/eligibility/util";

interface Selectors {
  eligibilityState: EligibilityState;
}
interface ActionDispatchers {
  getEligibilityDetails: (data: GetEligibilityDetails) => void;
  saveEligibilityDetails: (data: SaveEligibilityRequest) => void;
  changeLoanCalculationType: (data: LoanCalculationType) => void;
  initializeEligibilityId: (redirect: () => void) => void;
  updateEligibilityDetails: (data: EligibilityDetails) => void;
  startLoanApplication:(data:GetStartedLoanCalculation) => void;
  fetchLoanCalculation:(data:string,silent?:boolean)=>void;
}

const useEligibilityDetails = (): Selectors & ActionDispatchers => {
  const dispatch = useDispatch<Dispatch<AnyAction>>();
  const selectors = useSelector(stateSelector);
  const actionDispatchers = useMemo(() => actions(dispatch), [dispatch]);

  return { ...selectors, ...actionDispatchers };
};

const stateSelector = (state: ApplicationState): Selectors => ({
  eligibilityState: state.eligibilityState
});

const actions = (dispatch: Dispatch<AnyAction>): ActionDispatchers => ({
  getEligibilityDetails: (data: GetEligibilityDetails) => {
    dispatch(eligibilityActions.eligibilityDetails.started(data));
  },
  saveEligibilityDetails: (data: SaveEligibilityRequest) => {
    dispatch(eligibilityActions.saveEligibilityDetails.started(data));
  },
  changeLoanCalculationType: (data: LoanCalculationType) => {
    dispatch(eligibilityActions.changeLoanCalculationType(data));
  },
  initializeEligibilityId: (redirect: () => void) => {
    dispatch(eligibilityActions.initializeEligibilityId.started({ redirect }));
  },
  updateEligibilityDetails: (data: EligibilityDetails) => {
    dispatch(
      eligibilityActions.eligibilityDetails.done({
        params: {},
        result: formatEligibilityDetails(data)
      })
    );
  },
  startLoanApplication: (data:GetStartedLoanCalculation)=>{
    dispatch(
      eligibilityActions.startLoanCalculation.started(data)
    )
  },
  fetchLoanCalculation:(eligibilityId:string, silent = false)=>{
    dispatch(eligibilityActions.fetchLoanCalculation.started({eligibilityId, silent}))
  }
});

export default useEligibilityDetails;
